// src/pages/ReportsList.js
import { List, ListItemButton, ListItemText } from "@mui/material";
import { Link } from "react-router-dom";

const reports = [
    { id: "services-income", label: "Services & Income" },
    { id: "workers-income", label: "Workers & Income" },
    // ...future reports
];

export default function ReportsList() {
    return (

        <List>
            {reports.map((report) => (
                <ListItemButton
                    key={report.id}
                    component={Link}
                    to={`/reports/${report.id}`}
                >
                    <ListItemText primary={report.label} />
                </ListItemButton>
            ))}
        </List>

    );
}